// extracted by mini-css-extract-plugin
export var box = "Statistics-module--box--5cbe7";
export var box_md = "Statistics-module--box_md--3c847";
export var box_xmd = "Statistics-module--box_xmd--7a2d0";
export var box_flex = "Statistics-module--box_flex--b621c";
export var box_lg = "Statistics-module--box_lg--8acdd";
export var box_sm = "Statistics-module--box_sm--5b96c";
export var box_outer = "Statistics-module--box_outer--3a07a";
export var box_whiteBg = "Statistics-module--box_white-bg--1c79a";
export var box_noMarginBottom = "Statistics-module--box_no-margin-bottom--4f27d";
export var box_noPadding = "Statistics-module--box_no-padding--28f9b";
export var box_outerGray = "Statistics-module--box_outer-gray--e935f";
export var box_dark = "Statistics-module--box_dark--8fa3e";
export var box_zIndex = "Statistics-module--box_z-index--071d7";
export var box_zIndex6 = "Statistics-module--box_z-index-6--b1907";
export var box_eventsWithLine = "Statistics-module--box_events-with-line--047ce";
export var box_featuresAo = "Statistics-module--box_features-ao--18c5a";
export var box_verticalPaddings = "Statistics-module--box_vertical-paddings--3c579";
export var clearP = "Statistics-module--clearP--cc686";
export var clearP_vc = "Statistics-module--clearP_vc--f84fd";
export var layout = "Statistics-module--layout--543d3";
export var card = "Statistics-module--card--97719";
export var number = "Statistics-module--number--1a25c";
export var text = "Statistics-module--text--1a306";
export var link = "Statistics-module--link--e751a";
export var skeleton = "Statistics-module--skeleton--4b713";
export var placeHolderShimmer = "Statistics-module--placeHolderShimmer--25b08";
export var fadeInAnimation = "Statistics-module--fadeInAnimation--8a42b";